import { z } from "zod";
import { DatastoreType } from "../../../types";

export interface ConnectionProps {
  typeData: {
    name: string;
    type: DatastoreType;
    description: string;
    connection?: Record<string, unknown>;
  };
  handleBack: () => void;
  handleConnectionSubmit?: (data: Record<string, unknown>) => void;
  /** Pending state of the create mutation for connection types that create
   * the datastore directly from this step (currently Snowflake). */
  isSubmitting?: boolean;
}

export interface SnowflakeConnectionData {
  account: string;
  username: string;
  password: string;
  role?: string;
  warehouse?: string;
}

export interface PostgresConnectionData {
  host: string;
  port: string;
  database: string;
  username: string;
  password: string;
}

export interface TableauConnectionData {
  url: string;
  siteName: string;
  patName: string;
  patSecret: string;
}

// Tableau Project Schema
export const TableauProjectSchema = z.object({
  id: z.string(),
  name: z.string(),
  parent_project_id: z.string().optional(),
  description: z.string().optional(),
  path: z.string().optional(),
  content_permissions: z.string().optional(),
});

export type TableauProject = z.infer<typeof TableauProjectSchema>;

export interface ProjectNode extends TableauProject {
  children: ProjectNode[];
}
